import { IHttpApi } from '@cian/http-api';
import {
  createGetNewbuildingPolygonsModel,
  IGetNewbuildingPolygonsRequest,
  IGetNewbuildingPolygonsResponseError,
} from '../repositories/newbuilding-mvk/v2/get-newbuilding-polygons';

export async function getNewbuildingMVK(httpApi: IHttpApi, parameters: IGetNewbuildingPolygonsRequest) {
  const { response, statusCode } = await httpApi.fetch(createGetNewbuildingPolygonsModel(parameters));

  if (statusCode !== 200 || (response as IGetNewbuildingPolygonsResponseError).errors) {
    throw response;
  }

  return response;
}
